window.VH = window.VH === undefined ? {} : window.VH;
VH.Sidebar = {
    sidebar: false,

    toggle: function toggle(e) {
        let _t = VH.Sidebar;
        const isClick = !!(e && e.type === 'click');

        VH.Helper.b.toggleClass("sidebar-toggled");
        _t.sidebar.toggleClass("toggled");
        if (_t.sidebar.hasClass("toggled")) {
            $('.collapse', _t.sidebar).collapse('hide');
        }

        if (isClick) {
            const collapsed = VH.Helper.b.hasClass('sidebar-toggled') ? 1 : 0;
            $.post('/api/v1/ui/update-state', {collapsed: collapsed});
        }
    },

    resize: function () {
        let _t = VH.Sidebar,
            width = VH.Helper.w.width();
        if (width < 768 && !_t.sidebar.hasClass("toggled")) {
            _t.toggle();
        }
    },

    init: function init() {
        let _t = VH.Sidebar;
        _t.sidebar = $(".sidebar");

        if (_t.sidebar.hasClass("toggled")) {
            $('.collapse', _t.sidebar).removeClass('show');
        }

        $("#sidebarToggle, #sidebarToggleTop").on('click', _t.toggle);

        $(document).on('click', function (e) {
            if (!_t.sidebar.hasClass("toggled")) {
                return;
            }
            if ($(e.target).closest(_t.sidebar).length) {
                return;
            }
            $('.collapse.show', _t.sidebar).collapse('hide');
        });

        VH.Helper.w.resize(_t.resize);
        _t.resize();
    }
};
